import React from 'react'
import { DatePickerContext } from './date-picker-root'
import { OverrideComponentProps } from '../utils/overridable-component-helper'
import { composeEventHandlers } from '../utils/compose-event-handlers'

export type DatePickerPrevProps<Tag extends React.ElementType<any>> = OverrideComponentProps<Tag>

export const DatePickerPrev = React.forwardRef<HTMLDivElement, DatePickerPrevProps<any>>(
  ({ as = 'button', ...props }, ref) => {
    const context = React.useContext(DatePickerContext)
    if (!context) {
      throw new Error('Cannot find date picker context')
    } else {
      return React.createElement(as, {
        ...props,
        ref: ref,
        onClick: composeEventHandlers(props.onClick, context.goToPreviousMonth)
      })
    }
  }
) as WithForwardRefType

DatePickerPrev.displayName = 'DatePickerPrev'

interface WithForwardRefType extends React.FC<DatePickerPrevProps<React.ElementType<any>>> {
  <T extends React.ElementType<any> = 'button'>(props: DatePickerPrevProps<T>): ReturnType<React.FC<DatePickerPrevProps<T>>>
}
